module.exports = {"title":"Pode entrar que a casa é sua ;)","forgotpassword":"Esqueceu sua senha?","authError":"Tem algo errado com seu login ou sua senha. Tente novamente.","authCode":{"unauthorized":401,"locked":423},"redirect":{"dashboard":"/minha-veloe/resumo","canceledAccount":"/perfil/conta-cancelada"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/Login/data.json
// module id = 2116
// module chunks = 0